import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import vstqr from '../stickySide/images/visitorQRCode.png'
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
interface UserStructure {
  profile: string;
  id: number;
  name: string;
  email: string;
  delete: number;
  role:string;
  designation:string;
  company_name:string;
  Facebook:string;
  Linkedin:string;
  point:number;
  number:number;
}
const VisitorRegistor = () => {
  const api = process.env.REACT_APP_API_URL as string;
    const [isExpressModalOpen, setExpressModalOpen] = useState<boolean>(false);
    const [isVisitorModalOpen, setVisitorModalOpen] = useState<boolean>(false);
    const [isResistationModalOpen, setRegistationModalOpen] = useState<boolean>(false);
  
  
    const [selectedFacility, setSelectedFacility] = useState<string | null>(null);
    const [selectedTshirtSize, setselectedTshirtSize] = useState<string | null>(null);
    const [selectedFile, setSelectedFile] = useState<String | null>(null); 
  const [userDetails, setuserDetails] = useState<UserStructure[]>([]);
  const visitorModalRef = useRef<HTMLDivElement>(null);
  
   const handleVisitorSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
     event.preventDefault();
   
     // Example form data collection
     const formData = new FormData(event.currentTarget);
     const data = {
       profilePicture: formData.get('profilePicture'), // File object
       fullName: formData.get('fullName'),
       mobile: formData.get('mobile'),
       invitedBy: formData.get('invitedBy'),
       companyName: formData.get('companyName'),
       address: formData.get('address'),
       category: formData.get('category'),
   
       // Payment checkboxes — collect all selected values
       paymentDone: formData.getAll('paymentDone'), // Returns an array like ["PayTM", "GPay"]
   
       paymentDate: formData.get('paymentDate'),
       transactionId: formData.get('transactionId'),
       paymentScreenshot: formData.get('paymentScreenshot'), // File object
     };
   
   
     try {
       const response = await axios.post(
         `${api}/auth/visitor-registration`,
         formData,
         {
           headers: {
             'Content-Type': 'multipart/form-data',
           },
         }
       );
   
       if (response.status >= 200 && response.status < 300) {
         setVisitorModalOpen(false);
         window.location.href = '/'
       } else {
         console.error(
           'Failed to submit Visitor Registration form:',
           response.data.message || 'Unknown error'
         );
       }
     } catch (error) {
       if (axios.isAxiosError(error)) {
         console.error(
           'Error submitting Visitor Registration form:',
           error.response?.data?.message || error.message
         );
       } else {
         console.error('Unexpected error:', error);
       }
     }
   
     setVisitorModalOpen(false);
   };
      useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.get<UserStructure[]>(
            `${api}/auth/allusersinfo`
          );
  
          setuserDetails(response.data);
        } catch (error) {
          console.error("user Not Found:", error);
        }
      };
  
      fetchData();
    }, []);
  return (
    <div> 
        <Header/>
        <div className=" bg-[#1E2A3A] flex justify-center py-14">
    <div
      className="bg-white p-6 rounded-lg w-[95%] md:w-[80%] lg:w-[60%] "
      ref={visitorModalRef}
    >
      <h2 className="text-xl font-bold mb-4">Visitor Registration Form</h2>
      <form onSubmit={handleVisitorSubmit}>
        {/* Upload Profile Picture */}
        <div className="mb-4">
          <label className="block">
            Upload Profile Picture:
            <input
              type="file"
              name="profilePicture"
              className="w-full border p-2 rounded mt-1"
              accept="image/*"
              required
            />
          </label>
        </div>

        {/* Full Name & Mobile No */}
        <div className="flex flex-col md:flex-row gap-4 mb-4">
          <label className="w-full md:w-1/2">
            Full Name:
            <input type="text" className="w-full border p-2 rounded mt-1" name="fullName" required />
          </label>
          <label className="w-full md:w-1/2">
            Mobile No.:
            <input type="tel" className="w-full border p-2 rounded mt-1" name="mobile" required />
          </label>
        </div>

        {/* Invited By & Company Name */}
        <div className="flex flex-col md:flex-row gap-4 mb-4">
          <label className="w-full md:w-1/2">
            Invited By:
            <select name="invitedBy" className="w-full border p-2 rounded mt-1" required>
              <option value="">Select User</option>
               {userDetails
  ?.filter(
    user =>
      user.name?.toLowerCase() !== "rajnish" &&
      user.name?.toLowerCase() !== "admin"
  )
  .map(user => (
    <option key={user.id} value={user.id}>
      {user.name}
    </option>
  ))}
            </select>
          </label>
          <label className="w-full md:w-1/2">
            Company Name:
            <input type="text" className="w-full border p-2 rounded mt-1" name="companyName" required />
          </label>
        </div>

        {/* Business Classification */}
        <div className="flex flex-col md:flex-row gap-4 mb-4">
           <label className="w-full md:w-1/2">
            Address:
            <input type="text" className="w-full border p-2 rounded mt-1" name="address" required />
          </label>
          <label className="w-full md:w-1/2">
            Business Classification / Category:
            <input type="text" className="w-full border p-2 rounded mt-1" name="category" required />
          </label>
        </div>

        {/* Payment Done (Checkboxes) */}
        {/* Payment Done (Radio Buttons) */}
<div className="mb-4">
  <label className="block mb-1">Payment Done:</label>
  <div className="flex flex-col sm:flex-row gap-4">
    {/* <label className="flex items-center">
      <input type="radio" name="paymentDone" value="Members" className="mr-2" required />
      For Members (Nil)
    </label> */}
    <label className="flex items-center">
      <input type="radio" name="paymentDone" value="Guests" className="mr-2" />
      For New Guests 600/-
    </label>
  </div>
</div>


        {/* Payment Date, Transaction ID, Payment Screenshot */}
        <div className="flex flex-col md:flex-row gap-4 mb-4">
          <label className="w-full md:w-1/3">
            Payment Date:
            <input type="date" className="w-full border p-2 rounded mt-1" name="paymentDate" required />
          </label>
          <label className="w-full md:w-1/3">
            Transaction ID:
            <input
              type="text"
              className="w-full border p-2 rounded mt-1"
              name="transactionId"
              placeholder="Enter Transaction ID"
              required
            />
          </label>
          <label className="w-full md:w-1/3">
            Upload Payment Screenshot:
            <input
              type="file"
              name="paymentScreenshot"
              className="w-full border p-2 rounded mt-1"
              accept="image/*"
              required
            />
          </label>
        </div>

        <div className="mb-6 text-center">
  <img
     src={vstqr} // Replace with your actual QR image path
    alt="QR Code"
    className="mx-auto w-40 h-40 object-contain mb-4"
  />
  <p className="text-sm font-medium text-gray-700">Venue Fee: ₹600/-</p>
  {/* <p className="text-sm font-medium text-gray-700">₹800/- (after 15 Aug 2025)</p> */}
</div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-2 justify-end mt-6">
          <button
            className="bg-[#02256D] rounded text-white font-medium px-6 py-2 hover:bg-[#011e5a] transition"
            type="submit"
          >
            Submit
          </button>
          <button
            className="bg-red-600 rounded text-white font-medium px-6 py-2 hover:bg-red-700 transition"
            type="button"
            onClick={() => setVisitorModalOpen(false)}
          >
            Close
          </button>
        </div>
      </form>
    </div>
  </div>
  <Footer/>
  </div>
  )
}

export default VisitorRegistor